import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';

import { ErinnerungenComponent } from '.';
import { PostAbmeldenCommandModule, PostErinnerungCommandModule } from '../../commands';

@NgModule({
  imports: [LIB_CommonModule, PostAbmeldenCommandModule, PostErinnerungCommandModule],
  declarations: [ErinnerungenComponent],
  exports: [ErinnerungenComponent],
})
export class ErinnerungenComponentModule {}
